import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { PropertyActivitiesCrossSell } from '@shared-ui/retail-lodging-property-activities-cross-sell';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { MultiItemStore } from 'stores/multi-item-store';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

interface SharedUiPropertyActivitiesCrossSellProps extends SharedUiWrapperProps {
  currentHotel?: CurrentHotelStore;
  multiItem?: MultiItemStore;
}

export const PropertyActivitiesCrossSellWrapper: React.FC<SharedUiPropertyActivitiesCrossSellProps> = inject('currentHotel')(
  observer(({ inputs }) => <PropertyActivitiesCrossSell sectionRef="Offers" inputs={inputs} />)
);

PropertyActivitiesCrossSellWrapper.displayName = 'PropertyActivitiesCrossSellWrapper';

export const SharedUiPropertyActivitiesCrossSellWrapper = withSharedUiPropertyOffers(PropertyActivitiesCrossSellWrapper);
